import { Box, Button } from "@material-ui/core"
import Add from "@material-ui/icons/Add"
import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useBrandName } from "../../../hooks"

import type { Bundle } from "../../../redux"
import { Body1, CardTemplateContainer, LinkButton } from "../../atoms"
import { BundleListItem } from "../../molecules"

import "./bosatlas-bundle-list.styles.scss"

export interface IBosatlasBundleListProps {
  bundles: Bundle[]
  showAllButtonVisible?: boolean
  noBundlesMessage: string
  disableEditing?: boolean | undefined
  startBundleEdit?: (bundle?: Bundle) => void
  onViewBundleContentClick: (bundleId: string) => void
}

export function BosatlasBundleList(props: IBosatlasBundleListProps): ReactElement {
  const { bundles, showAllButtonVisible, noBundlesMessage, disableEditing, startBundleEdit, onViewBundleContentClick } =
    props

  const { t } = useTranslation("folder")
  const history = useHistory()
  const brandName: string = useBrandName()

  function handleStartEdit(bundle?: Bundle): void {
    if (!disableEditing && startBundleEdit) startBundleEdit(bundle)
  }

  return (
    <Box className="bosatlas-bundle-list">
      {bundles.length > 0 ? (
        <>
          <CardTemplateContainer columns={3}>
            {bundles.map((bundle: Bundle, index: number) => (
              <BundleListItem
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO fix in later PR
                key={index}
                disableEditing={disableEditing}
                bundle={bundle}
                onEditClick={() => handleStartEdit(bundle)}
                onViewContentClick={onViewBundleContentClick}
              />
            ))}
          </CardTemplateContainer>
          {showAllButtonVisible && (
            <LinkButton
              className="bosatlas-show-all-bundles-button"
              onClick={() => history.push(`Mijn${brandName}/bundles`)}
            >
              {t("viewFolders")}
            </LinkButton>
          )}
        </>
      ) : (
        <Box className="no-bundles-box">
          <Body1>{noBundlesMessage}</Body1>
          {!disableEditing && (
            <Button onClick={() => handleStartEdit()} variant="outlined" color="primary" className="add-button">
              <Add />
              {t("createNewFolder")}
            </Button>
          )}
        </Box>
      )}
    </Box>
  )
}
